import { Validator } from '@vista-digital/validator';
import { defaultOccFormFieldValidationConfig, occFormFieldValidationConfigValidator } from './form-field-validation';
export const defaultOccFormConfig = {
    enableFloatingInputLabels: false,
    fieldValidation: defaultOccFormFieldValidationConfig,
    suggestedEmailDomains: [
        // Custom known domains, sorted alphabetically
        '163.com',
        'allstate.com',
        'bigpond.com',
        'bluewin.ch',
        'gmx.ch',
        'gmx.de',
        'hotmail.com',
        'kw.com',
        'libero.it',
        'live.com',
        'mac.com',
        'mail.com',
        'mail.ru',
        'moe.edu.sg',
        'naver.com',
        'online.no',
        'outlook.com',
        'rediffmail.com',
        'remax.net',
        'shawinc.com',
        'statefarm.com',
        'tcd.ie',
        'vista.co',
        'yahoo.com'
    ]
};
export const occFormConfigValidator = Validator.object({
    enableFloatingInputLabels: Validator.boolean(),
    fieldValidation: occFormFieldValidationConfigValidator,
    suggestedEmailDomains: Validator.array({ items: Validator.nonEmptyString })
});
//# sourceMappingURL=form.js.map